import i18n from '@/i18n'
import store from '@/store'
import { sendLog } from '@/utils/log'
import { ApiError } from '@/api/error'
import { toError } from '@/utils/error'

export const genericNetworkErrorMessage = i18n.t('errorGeneral')

export function showGenericNetworkError() {
  alert(genericNetworkErrorMessage)
}

// セッションエラーを確認する
// return true: セッションが切れたので、ログイン画面に遷移するので、以降の処理では遷移しないようにする
// return false: それ以外のAPIエラーなので、通常のエラー処理を行う
export async function handleUnauthorized(e: Error | unknown) {
  const error = toError(e)

  if (error instanceof ApiError && error.status === 401) {
    // 現在のパスを保存（ログイン成功後のリダイレクト用）
    const currentPath = window.location.pathname + window.location.search
    if (window.location.pathname !== '/login'){
      sessionStorage.setItem('redirect_after_login', currentPath)
    }

    // セッション切れなのでトークンを消す
    store.dispatch('session/logoutExpired', error.errorCode)
    store.dispatch('pages/moveToLogin')
    return true
  }
  await sendApiWarning(error)
  showGenericNetworkError()

  return false
}

export async function sendApiWarning(e: Error | unknown) {
  const error = toError(e)

  if (!(error instanceof ApiError)) {
    await sendLog(error.message, 'warning')
    return
  }

  await sendLog(
    `api request failed. url:${error.url} status:${error.status} ${error.message}`,
    'warning'
  )
}
